































import {Component, Prop, Vue} from "vue-property-decorator";
    import StoreNavigationBar from "../partials/StoreNavigationBar.vue";
    import StoreFooter from "../partials/StoreFooter.vue";
    import DefaultHeader from "@/components/partials/DefaultHeader.vue";
import {ResellerInformation} from "@/interfaces/entities/CustomerProfile";

@Component({
  components: {
    DefaultHeader,
      StoreFooter,
    StoreNavigationBar
  }
})
    export default class DefaultLayout extends Vue {
        @Prop({type: Boolean, default: true}) showNav!: boolean;
        @Prop({type: Boolean, default: true}) showFooter!: boolean;
        @Prop({type: Boolean, default: false}) shareButton!: boolean;
        @Prop({type: String, default: null}) profileLink?: string;
        @Prop({type: Object, default: null}) resellerInformation?: ResellerInformation;
        get previousView(): boolean {
            return this.$store.state.previousView;
        }

        get isMobile(): boolean {
            return this.$store.state.isMobile;
        }

        //  These used to key off resellerInformation.backgroundColor, which no longer paints
        //  anything - the two places that applied it had been commented out, leaving it as an
        //  accidental flag. Both now key off headerColor, the property that actually brands this
        //  layout. Note the old checks were `?.backgroundColor !== null`, which is `undefined
        //  !== null` when there is no reseller information at all, i.e. always true.
        get isBranded(): boolean {
            return !!this.resellerInformation?.headerColor;
        }

        get headerHeight(): string {
            return this.isBranded ? "110px" : this.$store.state.headerHeight;
        }

        get headerBackgroundColor(): string {
            return this.resellerInformation?.headerColor || "rgb(12, 14, 17)";
        }

        //  Our gradient would fight a reseller's own header colour.
        get showGradient(): boolean {
            return !this.isBranded;
        }
    }
